/**
 * Polja obrasca preslikana na ključeve koje vraća poslužitelj uz položaje i pouzdanost. Bez ove
 * mape obrazac ne bi znao koji okvir na dokumentu pripada kojem unosu.
 */
export const FIELD_KEYS: Record<string, string> = {
  supplierName: "supplier_name",
  supplierOIB: "supplier_oib",
  invoiceNumber: "invoice_number",
  invoiceDate: "invoice_date",
  dueDate: "due_date",
  total: "total",
  totalWithoutTax: "total_without_tax",
  totalTax: "total_tax",
};

/** Nazivi polja za oznaku na dokumentu — na hover se vidi što je s tog mjesta pročitano. */
export const FIELD_LABELS: Record<string, string> = {
  supplier_name: "Naziv dobavljača",
  supplier_oib: "OIB",
  invoice_number: "Broj računa",
  invoice_date: "Datum računa",
  due_date: "Datum dospijeća",
  total: "Ukupno s PDV-om",
  total_without_tax: "Ukupno bez PDV-a",
  total_tax: "PDV",
};

/** Podaci o dobavljaču i računu se boje drukčije od iznosa, da se na stranici razaznaju. */
export const FIELD_HIGHLIGHT_GROUPS: Record<string, "info" | "amount"> = {
  supplier_name: "info",
  supplier_oib: "info",
  invoice_number: "info",
  invoice_date: "info",
  due_date: "info",
  total: "amount",
  total_without_tax: "amount",
  total_tax: "amount",
};

/** Nastavci koji se prikazuju kao slika; sve ostalo ide kroz preglednik PDF-a. */
export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp"];
